import React from 'react';
import { Tooltip } from 'antd';
import { TOOLS } from '../../utils/mapDrawingBoard/toolDefs';

/** 侧栏工具按钮列表 */
export default function DrawingToolList({ tool, selectTool }) {
  return (
    <div className="zhxt-draw-tools">
      {TOOLS.map((t) => (
        <Tooltip key={t.key} title={t.tip} placement="right">
          <button
            type="button"
            className={`zhxt-draw-tool-btn ${tool === t.key ? 'active' : ''} ${t.key === 'eraser' ? 'danger' : ''}`}
            onClick={() => selectTool(t.key)}
          >
            <span className="zhxt-draw-tool-icon">{t.icon}</span>
            <span>{t.title}</span>
          </button>
        </Tooltip>
      ))}
    </div>
  );
}
